// custom error, see https://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript

// custom error factory
const e = type => {
  function E (message, extras = {}) {
    if (!(this instanceof E)) {
      return new E(message, extras)
    }
    this.name = type
    this.message = message
    this.stack = (new Error()).stack
    Object.assign(this, extras)
  }
  // static method to cast a more generic error to this custom error type
  E.cast = (otherError) => {
    const newError = E(otherError.message)
    newError.stack = otherError.stack
    return newError
  }
  E.prototype = new Error()
  // override the function name for easier to read logs/traces
  Object.defineProperty(E, 'name', { value: type })
  return E
}

// An error that was sent by the ApiV3 server
// This could be something like:
// - A failed activerecord validation
// - Missing request parameters
// - Permissions issues
export const ServerError = e('ServerError')

// An error caused by an invalid JSON response
// This is likely caused by the server-side bug sending
// back HTML stack traces
export const ParseError = e('ParseError')

// An error caused by an issue in transit
// This could be something like:
// - The user is not connected to the internet
// - The request timed out
// - The api server is offline
export const NetworkError = e('NetworkError')
